import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as rootCausesServiceClear } from './rootCausesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'rootCauses',
  serviceTableName: 'rootCausesService',
  serviceClearFunction: rootCausesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.rootCauses]),
});
